// @ts-nocheck
import React, { Suspense, useReducer } from 'react';
import TCardSkeleton from './TCardSkeleton';
import en from './i18n/en.json';
import es from './i18n/es.json';
import it from './i18n/it.json';
import pt from './i18n/pt.json';
import TCardFlow from './TCardFlow';
import TCardContext, { REDUCERS, STATES } from './TCardContext';
import useRegisteredTranslation from '@dev-togetherprice/hooks.use-register-translation';
const TRANSLATIONS = { en, es, it, pt };
const TCard = ({ showWallet, onError = console.error, onSelect = console.log, noSave, }) => {
    const { t } = useRegisteredTranslation('TCard', TRANSLATIONS);
    const [state, dispatch] = useReducer(REDUCERS, Object.assign(Object.assign({}, STATES), { t,
        onError,
        onSelect,
        showWallet,
        noSave }));
    return (React.createElement(TCardContext.Provider, { value: { state, dispatch } },
        React.createElement(Suspense, { fallback: React.createElement(TCardSkeleton, null) },
            React.createElement(TCardFlow, null))));
};
export default TCard;
